// Generated by ReScript, PLEASE EDIT WITH CARE

import * as List from "../../../../../../../../../../node_modules/rescript/lib/es6/list.js";
import * as Curry from "../../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Formality from "../../../../../../../../../../node_modules/re-formality/src/Formality.bs.js";
import * as Belt_Float from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Float.js";
import * as Caml_array from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_array.js";
import * as Belt_Option from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "../../../../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";
import * as Caml_format from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_format.js";
import * as Caml_option from "../../../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as Timestamp$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";
import * as Formality__ReactUpdate from "../../../../../../../../../../node_modules/re-formality/src/Formality__ReactUpdate.bs.js";
import * as CreateModificationUtils from "../../../../../../../pricing-dashboard/view/components/library/utils/CreateModificationUtils.bs.js";
import * as AllocationDashboardUtils from "../../../../utils/AllocationDashboardUtils.bs.js";
import * as PrimitiveFormTypes$Catalyst from "../../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/form/PrimitiveFormTypes.bs.js";

function validateFilterTypes(radius, errorMessage) {
  if (radius === undefined) {
    return {
            TAG: /* Error */1,
            _0: errorMessage + " required"
          };
  }
  var value_before_and_after_decimal = radius.split(".");
  return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                  TAG: /* Float */3,
                  _0: radius
                }), (function (filter) {
                if (filter <= 0.0) {
                  return {
                          TAG: /* Error */1,
                          _0: errorMessage + " should be greater than 0"
                        };
                } else if (value_before_and_after_decimal.length > 1 && Caml_array.get(value_before_and_after_decimal, 1).length > 2) {
                  return {
                          TAG: /* Error */1,
                          _0: "Valid precision is upto 2 decimal places (e.g. 10.75)"
                        };
                } else {
                  return {
                          TAG: /* Ok */0,
                          _0: Belt_Float.fromString(filter.toFixed(2))
                        };
                }
              }));
}

var validators_maxDryRunDelta = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var subType = param.subType;
      if (subType !== undefined && subType >= 2) {
        return {
                TAG: /* Ok */0,
                _0: Belt_Option.flatMap(param.maxDryRunDelta, Belt_Float.fromString)
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_maxDryRunAutomatic = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var subType = param.subType;
      if (subType !== undefined && subType >= 2) {
        return validateFilterTypes(param.maxDryRunAutomatic, "Automatic max dry run");
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_maxDryRunManual = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var subType = param.subType;
      if (subType !== undefined && subType >= 2) {
        return validateFilterTypes(param.maxDryRunManual, "Manual max dry run");
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_dryRunDelta = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var subType = param.subType;
      if (subType === 1) {
        return {
                TAG: /* Ok */0,
                _0: Belt_Option.flatMap(param.dryRunDelta, Belt_Float.fromString)
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_dryRunRatio = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var dryRunRatio = param.dryRunRatio;
      var subType = param.subType;
      if (subType === undefined) {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
      if (subType !== 1) {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
      if (dryRunRatio === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Dry run ratio required"
              };
      }
      var value_before_and_after_decimal = dryRunRatio.split(".");
      return Belt_Result.flatMap(PrimitiveFormTypes$Catalyst.getValue({
                      TAG: /* Float */3,
                      _0: dryRunRatio
                    }), (function (filter) {
                    if (filter <= 0.0) {
                      return {
                              TAG: /* Error */1,
                              _0: "Dry run ratio should be greater than 0"
                            };
                    } else if (filter > 2.0) {
                      return {
                              TAG: /* Error */1,
                              _0: "Dry run ratio should be less than or equal to 2"
                            };
                    } else if (value_before_and_after_decimal.length > 1 && Caml_array.get(value_before_and_after_decimal, 1).length > 2) {
                      return {
                              TAG: /* Error */1,
                              _0: "Valid precision is upto 2 decimal places (e.g. 1.67)"
                            };
                    } else {
                      return {
                              TAG: /* Ok */0,
                              _0: Belt_Float.fromString(filter.toFixed(2))
                            };
                    }
                  }));
    })
};

var validators_thresholdDistance = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var subType = param.subType;
      if (subType === 1) {
        return validateFilterTypes(param.thresholdDistance, "Threshold distance");
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_allocationRadiusDelta = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var subType = param.subType;
      if (subType === 0) {
        return {
                TAG: /* Ok */0,
                _0: Belt_Option.flatMap(param.allocationRadiusDelta, Belt_Float.fromString)
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_allocationRadiusAutomatic = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var subType = param.subType;
      if (subType === 0) {
        return validateFilterTypes(param.allocationRadiusAutomatic, "Automatic allocation radius");
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_allocationRadiusManual = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var subType = param.subType;
      if (subType === 0) {
        return validateFilterTypes(param.allocationRadiusManual, "Manual allocation radius");
      } else {
        return {
                TAG: /* Ok */0,
                _0: undefined
              };
      }
    })
};

var validators_subType = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var subType = param.subType;
      if (subType !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: subType
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Error"
              };
      }
    })
};

var validators_days = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var days = param.days;
      if (days) {
        return {
                TAG: /* Ok */0,
                _0: days
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: List.map((function (d) {
                        return d.value;
                      }), CreateModificationUtils.RepeatDays.daysOptions)
              };
      }
    })
};

var validators_endTime = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var endTime = param.endTime;
      var endDate = param.endDate;
      var startTime = param.startTime;
      var startDate = param.startDate;
      if (startDate !== undefined && endDate !== undefined && startTime !== undefined && endTime !== undefined && !Timestamp$Catalyst.isBefore(Belt_Option.getExn(AllocationDashboardUtils.CreateZonalOrClusterCampaigns.adjustTimeWithDate(Caml_option.some(Caml_option.valFromOption(startDate)), Caml_option.some(Caml_option.valFromOption(startTime)))), Belt_Option.getExn(AllocationDashboardUtils.CreateZonalOrClusterCampaigns.adjustTimeWithDate(Caml_option.some(Caml_option.valFromOption(endDate)), Caml_option.some(Caml_option.valFromOption(endTime)))))) {
        return {
                TAG: /* Error */1,
                _0: "End time should be more than start time"
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: endTime
              };
      }
    })
};

var validators_endDate = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var endDate = param.endDate;
      var startDate = param.startDate;
      if (startDate !== undefined && endDate !== undefined && Caml_obj.caml_greaterthan(Caml_option.valFromOption(startDate), Caml_option.valFromOption(endDate))) {
        return {
                TAG: /* Error */1,
                _0: "Start date should be less or equal to end date"
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: endDate
              };
      }
    })
};

var validators_startTime = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      return {
              TAG: /* Ok */0,
              _0: param.startTime
            };
    })
};

var validators_startDate = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var startDate = param.startDate;
      if (startDate !== undefined) {
        return {
                TAG: /* Ok */0,
                _0: Caml_option.some(Caml_option.valFromOption(startDate))
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Start date is required"
              };
      }
    })
};

var validators_campaignName = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var campaignName = param.campaignName;
      if (campaignName === undefined) {
        return {
                TAG: /* Error */1,
                _0: "Please enter Campaign name"
              };
      }
      var len = campaignName.length;
      if (len < 3) {
        return {
                TAG: /* Error */1,
                _0: "Campaign name cannot be less than 3 characters"
              };
      } else if (len > 60) {
        return {
                TAG: /* Error */1,
                _0: "Campaign name cannot be more than 60 characters"
              };
      } else {
        return {
                TAG: /* Ok */0,
                _0: campaignName
              };
      }
    })
};

var validators_clusters = {
  strategy: /* OnFirstSuccessOrFirstBlur */3,
  validate: (function (param) {
      var clusters = param.clusters;
      if (param.zones) {
        if (param.hasCluster) {
          if (clusters) {
            return {
                    TAG: /* Ok */0,
                    _0: List.map(Caml_format.caml_int_of_string, clusters)
                  };
          } else {
            return {
                    TAG: /* Error */1,
                    _0: "Please enter Clusters"
                  };
          }
        } else {
          return {
                  TAG: /* Ok */0,
                  _0: /* [] */0
                };
        }
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please select Zone first"
              };
      }
    })
};

var validators_zones = {
  strategy: /* OnSubmit */4,
  validate: (function (param) {
      var zones = param.zones;
      if (zones) {
        return {
                TAG: /* Ok */0,
                _0: List.map(Caml_format.caml_int_of_string, zones)
              };
      } else {
        return {
                TAG: /* Error */1,
                _0: "Please enter Zones"
              };
      }
    })
};

var validators = {
  maxDryRunDelta: validators_maxDryRunDelta,
  maxDryRunAutomatic: validators_maxDryRunAutomatic,
  maxDryRunManual: validators_maxDryRunManual,
  dryRunDelta: validators_dryRunDelta,
  dryRunRatio: validators_dryRunRatio,
  thresholdDistance: validators_thresholdDistance,
  allocationRadiusDelta: validators_allocationRadiusDelta,
  allocationRadiusAutomatic: validators_allocationRadiusAutomatic,
  allocationRadiusManual: validators_allocationRadiusManual,
  displayFilters: undefined,
  subType: validators_subType,
  _type: undefined,
  validations: undefined,
  days: validators_days,
  endTime: validators_endTime,
  endDate: validators_endDate,
  startTime: validators_startTime,
  startDate: validators_startDate,
  campaignName: validators_campaignName,
  clusters: validators_clusters,
  hasCluster: undefined,
  zones: validators_zones
};

function initialFieldsStatuses(_input) {
  return {
          maxDryRunDelta: /* Pristine */0,
          maxDryRunAutomatic: /* Pristine */0,
          maxDryRunManual: /* Pristine */0,
          dryRunDelta: /* Pristine */0,
          dryRunRatio: /* Pristine */0,
          thresholdDistance: /* Pristine */0,
          allocationRadiusDelta: /* Pristine */0,
          allocationRadiusAutomatic: /* Pristine */0,
          allocationRadiusManual: /* Pristine */0,
          displayFilters: /* Pristine */0,
          subType: /* Pristine */0,
          _type: /* Pristine */0,
          validations: /* Pristine */0,
          days: /* Pristine */0,
          endTime: /* Pristine */0,
          endDate: /* Pristine */0,
          startTime: /* Pristine */0,
          startDate: /* Pristine */0,
          campaignName: /* Pristine */0,
          clusters: /* Pristine */0,
          hasCluster: /* Pristine */0,
          zones: /* Pristine */0
        };
}

function initialState(input) {
  return {
          input: input,
          fieldsStatuses: initialFieldsStatuses(input),
          collectionsStatuses: undefined,
          formStatus: /* Editing */0,
          submissionStatus: /* NeverSubmitted */0
        };
}

function validateForm(input, validators, fieldsStatuses) {
  var match = fieldsStatuses.maxDryRunDelta;
  var match_0 = match ? match._0 : Curry._1(validators.maxDryRunDelta.validate, input);
  var match$1 = fieldsStatuses.maxDryRunAutomatic;
  var match_0$1 = match$1 ? match$1._0 : Curry._1(validators.maxDryRunAutomatic.validate, input);
  var match$2 = fieldsStatuses.maxDryRunManual;
  var match_0$2 = match$2 ? match$2._0 : Curry._1(validators.maxDryRunManual.validate, input);
  var match$3 = fieldsStatuses.dryRunDelta;
  var match_0$3 = match$3 ? match$3._0 : Curry._1(validators.dryRunDelta.validate, input);
  var match$4 = fieldsStatuses.dryRunRatio;
  var match_0$4 = match$4 ? match$4._0 : Curry._1(validators.dryRunRatio.validate, input);
  var match$5 = fieldsStatuses.thresholdDistance;
  var match_0$5 = match$5 ? match$5._0 : Curry._1(validators.thresholdDistance.validate, input);
  var match$6 = fieldsStatuses.allocationRadiusDelta;
  var match_0$6 = match$6 ? match$6._0 : Curry._1(validators.allocationRadiusDelta.validate, input);
  var match$7 = fieldsStatuses.allocationRadiusAutomatic;
  var match_0$7 = match$7 ? match$7._0 : Curry._1(validators.allocationRadiusAutomatic.validate, input);
  var match$8 = fieldsStatuses.allocationRadiusManual;
  var match_0$8 = match$8 ? match$8._0 : Curry._1(validators.allocationRadiusManual.validate, input);
  var match_0$9 = {
    TAG: /* Ok */0,
    _0: input.displayFilters
  };
  var match$9 = fieldsStatuses.subType;
  var match_0$10 = match$9 ? match$9._0 : Curry._1(validators.subType.validate, input);
  var match_0$11 = {
    TAG: /* Ok */0,
    _0: input._type
  };
  var match_0$12 = {
    TAG: /* Ok */0,
    _0: input.validations
  };
  var match$10 = fieldsStatuses.days;
  var match_0$13 = match$10 ? match$10._0 : Curry._1(validators.days.validate, input);
  var match$11 = fieldsStatuses.endTime;
  var match_0$14 = match$11 ? match$11._0 : Curry._1(validators.endTime.validate, input);
  var match$12 = fieldsStatuses.endDate;
  var match_0$15 = match$12 ? match$12._0 : Curry._1(validators.endDate.validate, input);
  var match$13 = fieldsStatuses.startTime;
  var match_0$16 = match$13 ? match$13._0 : Curry._1(validators.startTime.validate, input);
  var match$14 = fieldsStatuses.startDate;
  var match_0$17 = match$14 ? match$14._0 : Curry._1(validators.startDate.validate, input);
  var match$15 = fieldsStatuses.campaignName;
  var match_0$18 = match$15 ? match$15._0 : Curry._1(validators.campaignName.validate, input);
  var match$16 = fieldsStatuses.clusters;
  var match_0$19 = match$16 ? match$16._0 : Curry._1(validators.clusters.validate, input);
  var match_0$20 = {
    TAG: /* Ok */0,
    _0: input.hasCluster
  };
  var match$17 = fieldsStatuses.zones;
  var match_0$21 = match$17 ? match$17._0 : Curry._1(validators.zones.validate, input);
  var maxDryRunDeltaResult = match_0;
  var maxDryRunDeltaResult$1;
  if (maxDryRunDeltaResult.TAG === /* Ok */0) {
    var maxDryRunAutomaticResult = match_0$1;
    if (maxDryRunAutomaticResult.TAG === /* Ok */0) {
      var maxDryRunManualResult = match_0$2;
      if (maxDryRunManualResult.TAG === /* Ok */0) {
        var dryRunDeltaResult = match_0$3;
        if (dryRunDeltaResult.TAG === /* Ok */0) {
          var dryRunRatioResult = match_0$4;
          if (dryRunRatioResult.TAG === /* Ok */0) {
            var thresholdDistanceResult = match_0$5;
            if (thresholdDistanceResult.TAG === /* Ok */0) {
              var allocationRadiusDeltaResult = match_0$6;
              if (allocationRadiusDeltaResult.TAG === /* Ok */0) {
                var allocationRadiusAutomaticResult = match_0$7;
                if (allocationRadiusAutomaticResult.TAG === /* Ok */0) {
                  var allocationRadiusManualResult = match_0$8;
                  if (allocationRadiusManualResult.TAG === /* Ok */0) {
                    var displayFiltersResult = match_0$9;
                    if (displayFiltersResult.TAG === /* Ok */0) {
                      var subTypeResult = match_0$10;
                      if (subTypeResult.TAG === /* Ok */0) {
                        var _typeResult = match_0$11;
                        if (_typeResult.TAG === /* Ok */0) {
                          var validationsResult = match_0$12;
                          if (validationsResult.TAG === /* Ok */0) {
                            var daysResult = match_0$13;
                            if (daysResult.TAG === /* Ok */0) {
                              var endTimeResult = match_0$14;
                              if (endTimeResult.TAG === /* Ok */0) {
                                var endDateResult = match_0$15;
                                if (endDateResult.TAG === /* Ok */0) {
                                  var startTimeResult = match_0$16;
                                  if (startTimeResult.TAG === /* Ok */0) {
                                    var startDateResult = match_0$17;
                                    if (startDateResult.TAG === /* Ok */0) {
                                      var campaignNameResult = match_0$18;
                                      if (campaignNameResult.TAG === /* Ok */0) {
                                        var clustersResult = match_0$19;
                                        if (clustersResult.TAG === /* Ok */0) {
                                          var hasClusterResult = match_0$20;
                                          if (hasClusterResult.TAG === /* Ok */0) {
                                            var zonesResult = match_0$21;
                                            if (zonesResult.TAG === /* Ok */0) {
                                              return {
                                                      TAG: /* Valid */0,
                                                      output: {
                                                        zones: zonesResult._0,
                                                        hasCluster: hasClusterResult._0,
                                                        clusters: clustersResult._0,
                                                        campaignName: campaignNameResult._0,
                                                        startDate: startDateResult._0,
                                                        startTime: startTimeResult._0,
                                                        endDate: endDateResult._0,
                                                        endTime: endTimeResult._0,
                                                        days: daysResult._0,
                                                        validations: validationsResult._0,
                                                        _type: _typeResult._0,
                                                        subType: subTypeResult._0,
                                                        displayFilters: displayFiltersResult._0,
                                                        allocationRadiusManual: allocationRadiusManualResult._0,
                                                        allocationRadiusAutomatic: allocationRadiusAutomaticResult._0,
                                                        allocationRadiusDelta: allocationRadiusDeltaResult._0,
                                                        thresholdDistance: thresholdDistanceResult._0,
                                                        dryRunRatio: dryRunRatioResult._0,
                                                        dryRunDelta: dryRunDeltaResult._0,
                                                        maxDryRunManual: maxDryRunManualResult._0,
                                                        maxDryRunAutomatic: maxDryRunAutomaticResult._0,
                                                        maxDryRunDelta: maxDryRunDeltaResult._0
                                                      },
                                                      fieldsStatuses: {
                                                        maxDryRunDelta: /* Dirty */{
                                                          _0: maxDryRunDeltaResult,
                                                          _1: /* Shown */0
                                                        },
                                                        maxDryRunAutomatic: /* Dirty */{
                                                          _0: maxDryRunAutomaticResult,
                                                          _1: /* Shown */0
                                                        },
                                                        maxDryRunManual: /* Dirty */{
                                                          _0: maxDryRunManualResult,
                                                          _1: /* Shown */0
                                                        },
                                                        dryRunDelta: /* Dirty */{
                                                          _0: dryRunDeltaResult,
                                                          _1: /* Shown */0
                                                        },
                                                        dryRunRatio: /* Dirty */{
                                                          _0: dryRunRatioResult,
                                                          _1: /* Shown */0
                                                        },
                                                        thresholdDistance: /* Dirty */{
                                                          _0: thresholdDistanceResult,
                                                          _1: /* Shown */0
                                                        },
                                                        allocationRadiusDelta: /* Dirty */{
                                                          _0: allocationRadiusDeltaResult,
                                                          _1: /* Shown */0
                                                        },
                                                        allocationRadiusAutomatic: /* Dirty */{
                                                          _0: allocationRadiusAutomaticResult,
                                                          _1: /* Shown */0
                                                        },
                                                        allocationRadiusManual: /* Dirty */{
                                                          _0: allocationRadiusManualResult,
                                                          _1: /* Shown */0
                                                        },
                                                        displayFilters: /* Dirty */{
                                                          _0: displayFiltersResult,
                                                          _1: /* Hidden */1
                                                        },
                                                        subType: /* Dirty */{
                                                          _0: subTypeResult,
                                                          _1: /* Shown */0
                                                        },
                                                        _type: /* Dirty */{
                                                          _0: _typeResult,
                                                          _1: /* Hidden */1
                                                        },
                                                        validations: /* Dirty */{
                                                          _0: validationsResult,
                                                          _1: /* Hidden */1
                                                        },
                                                        days: /* Dirty */{
                                                          _0: daysResult,
                                                          _1: /* Shown */0
                                                        },
                                                        endTime: /* Dirty */{
                                                          _0: endTimeResult,
                                                          _1: /* Shown */0
                                                        },
                                                        endDate: /* Dirty */{
                                                          _0: endDateResult,
                                                          _1: /* Shown */0
                                                        },
                                                        startTime: /* Dirty */{
                                                          _0: startTimeResult,
                                                          _1: /* Shown */0
                                                        },
                                                        startDate: /* Dirty */{
                                                          _0: startDateResult,
                                                          _1: /* Shown */0
                                                        },
                                                        campaignName: /* Dirty */{
                                                          _0: campaignNameResult,
                                                          _1: /* Shown */0
                                                        },
                                                        clusters: /* Dirty */{
                                                          _0: clustersResult,
                                                          _1: /* Shown */0
                                                        },
                                                        hasCluster: /* Dirty */{
                                                          _0: hasClusterResult,
                                                          _1: /* Hidden */1
                                                        },
                                                        zones: /* Dirty */{
                                                          _0: zonesResult,
                                                          _1: /* Shown */0
                                                        }
                                                      },
                                                      collectionsStatuses: undefined
                                                    };
                                            }
                                            maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                                          } else {
                                            maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                                          }
                                        } else {
                                          maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                                        }
                                      } else {
                                        maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                                      }
                                    } else {
                                      maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                                    }
                                  } else {
                                    maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                                  }
                                } else {
                                  maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                                }
                              } else {
                                maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                              }
                            } else {
                              maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                            }
                          } else {
                            maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                          }
                        } else {
                          maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                        }
                      } else {
                        maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                      }
                    } else {
                      maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                    }
                  } else {
                    maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                  }
                } else {
                  maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
                }
              } else {
                maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
              }
            } else {
              maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
            }
          } else {
            maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
          }
        } else {
          maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
        }
      } else {
        maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
      }
    } else {
      maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
    }
  } else {
    maxDryRunDeltaResult$1 = maxDryRunDeltaResult;
  }
  return {
          TAG: /* Invalid */1,
          fieldsStatuses: {
            maxDryRunDelta: /* Dirty */{
              _0: maxDryRunDeltaResult$1,
              _1: /* Shown */0
            },
            maxDryRunAutomatic: /* Dirty */{
              _0: match_0$1,
              _1: /* Shown */0
            },
            maxDryRunManual: /* Dirty */{
              _0: match_0$2,
              _1: /* Shown */0
            },
            dryRunDelta: /* Dirty */{
              _0: match_0$3,
              _1: /* Shown */0
            },
            dryRunRatio: /* Dirty */{
              _0: match_0$4,
              _1: /* Shown */0
            },
            thresholdDistance: /* Dirty */{
              _0: match_0$5,
              _1: /* Shown */0
            },
            allocationRadiusDelta: /* Dirty */{
              _0: match_0$6,
              _1: /* Shown */0
            },
            allocationRadiusAutomatic: /* Dirty */{
              _0: match_0$7,
              _1: /* Shown */0
            },
            allocationRadiusManual: /* Dirty */{
              _0: match_0$8,
              _1: /* Shown */0
            },
            displayFilters: /* Dirty */{
              _0: match_0$9,
              _1: /* Hidden */1
            },
            subType: /* Dirty */{
              _0: match_0$10,
              _1: /* Shown */0
            },
            _type: /* Dirty */{
              _0: match_0$11,
              _1: /* Hidden */1
            },
            validations: /* Dirty */{
              _0: match_0$12,
              _1: /* Hidden */1
            },
            days: /* Dirty */{
              _0: match_0$13,
              _1: /* Shown */0
            },
            endTime: /* Dirty */{
              _0: match_0$14,
              _1: /* Shown */0
            },
            endDate: /* Dirty */{
              _0: match_0$15,
              _1: /* Shown */0
            },
            startTime: /* Dirty */{
              _0: match_0$16,
              _1: /* Shown */0
            },
            startDate: /* Dirty */{
              _0: match_0$17,
              _1: /* Shown */0
            },
            campaignName: /* Dirty */{
              _0: match_0$18,
              _1: /* Shown */0
            },
            clusters: /* Dirty */{
              _0: match_0$19,
              _1: /* Shown */0
            },
            hasCluster: /* Dirty */{
              _0: match_0$20,
              _1: /* Hidden */1
            },
            zones: /* Dirty */{
              _0: match_0$21,
              _1: /* Shown */0
            }
          },
          collectionsStatuses: undefined
        };
}

function useForm(initialInput, onSubmit) {
  var memoizedInitialState = React.useMemo((function () {
          return initialState(initialInput);
        }), [initialInput]);
  var match = Formality__ReactUpdate.useReducer(memoizedInitialState, (function (state, action) {
          if (typeof action === "number") {
            switch (action) {
              case /* BlurMaxDryRunDeltaField */0 :
                  var result = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.maxDryRunDelta, validators_maxDryRunDelta, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.maxDryRunDelta = status;
                          return newrecord;
                        }));
                  if (result !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurMaxDryRunAutomaticField */1 :
                  var result$1 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.maxDryRunAutomatic, validators_maxDryRunAutomatic, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.maxDryRunAutomatic = status;
                          return newrecord;
                        }));
                  if (result$1 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$1,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurMaxDryRunManualField */2 :
                  var result$2 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.maxDryRunManual, validators_maxDryRunManual, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.maxDryRunManual = status;
                          return newrecord;
                        }));
                  if (result$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$2,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurDryRunDeltaField */3 :
                  var result$3 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.dryRunDelta, validators_dryRunDelta, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.dryRunDelta = status;
                          return newrecord;
                        }));
                  if (result$3 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$3,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurDryRunRatioField */4 :
                  var result$4 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.dryRunRatio, validators_dryRunRatio, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.dryRunRatio = status;
                          return newrecord;
                        }));
                  if (result$4 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$4,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurThresholdDistanceField */5 :
                  var result$5 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.thresholdDistance, validators_thresholdDistance, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.thresholdDistance = status;
                          return newrecord;
                        }));
                  if (result$5 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$5,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurAllocationRadiusDeltaField */6 :
                  var result$6 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.allocationRadiusDelta, validators_allocationRadiusDelta, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.allocationRadiusDelta = status;
                          return newrecord;
                        }));
                  if (result$6 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$6,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurAllocationRadiusAutomaticField */7 :
                  var result$7 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.allocationRadiusAutomatic, validators_allocationRadiusAutomatic, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.allocationRadiusAutomatic = status;
                          return newrecord;
                        }));
                  if (result$7 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$7,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurAllocationRadiusManualField */8 :
                  var result$8 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.allocationRadiusManual, validators_allocationRadiusManual, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.allocationRadiusManual = status;
                          return newrecord;
                        }));
                  if (result$8 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$8,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurDisplayFiltersField */9 :
                  var result$9 = Formality.validateFieldOnBlurWithoutValidator(state.input.displayFilters, state.fieldsStatuses.displayFilters, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.displayFilters = status;
                          return newrecord;
                        }));
                  if (result$9 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$9,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurSubTypeField */10 :
                  var result$10 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.subType, validators_subType, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.subType = status;
                          return newrecord;
                        }));
                  if (result$10 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$10,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Blur_typeField */11 :
                  var result$11 = Formality.validateFieldOnBlurWithoutValidator(state.input._type, state.fieldsStatuses._type, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord._type = status;
                          return newrecord;
                        }));
                  if (result$11 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$11,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurValidationsField */12 :
                  var result$12 = Formality.validateFieldOnBlurWithoutValidator(state.input.validations, state.fieldsStatuses.validations, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.validations = status;
                          return newrecord;
                        }));
                  if (result$12 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$12,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurDaysField */13 :
                  var result$13 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.days, validators_days, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.days = status;
                          return newrecord;
                        }));
                  if (result$13 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$13,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurEndTimeField */14 :
                  var result$14 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.endTime, validators_endTime, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.endTime = status;
                          return newrecord;
                        }));
                  if (result$14 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$14,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurEndDateField */15 :
                  var result$15 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.endDate, validators_endDate, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.endDate = status;
                          return newrecord;
                        }));
                  if (result$15 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$15,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurStartTimeField */16 :
                  var result$16 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.startTime, validators_startTime, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.startTime = status;
                          return newrecord;
                        }));
                  if (result$16 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$16,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurStartDateField */17 :
                  var result$17 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.startDate, validators_startDate, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.startDate = status;
                          return newrecord;
                        }));
                  if (result$17 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$17,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurCampaignNameField */18 :
                  var result$18 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.campaignName, validators_campaignName, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.campaignName = status;
                          return newrecord;
                        }));
                  if (result$18 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$18,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurClustersField */19 :
                  var result$19 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.clusters, validators_clusters, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.clusters = status;
                          return newrecord;
                        }));
                  if (result$19 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$19,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurHasClusterField */20 :
                  var result$20 = Formality.validateFieldOnBlurWithoutValidator(state.input.hasCluster, state.fieldsStatuses.hasCluster, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.hasCluster = status;
                          return newrecord;
                        }));
                  if (result$20 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$20,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* BlurZonesField */21 :
                  var result$21 = Formality.validateFieldOnBlurWithValidator(state.input, state.fieldsStatuses.zones, validators_zones, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                          newrecord.zones = status;
                          return newrecord;
                        }));
                  if (result$21 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: result$21,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: state.formStatus,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              case /* Submit */22 :
                  var match = state.formStatus;
                  if (typeof match !== "number" && match.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  var match$1 = validateForm(state.input, validators, state.fieldsStatuses);
                  if (match$1.TAG !== /* Valid */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: match$1.fieldsStatuses,
                              collectionsStatuses: match$1.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: /* AttemptedToSubmit */1
                            }
                          };
                  }
                  var output = match$1.output;
                  var error = state.formStatus;
                  var tmp;
                  tmp = typeof error === "number" || error.TAG !== /* SubmissionFailed */1 ? undefined : Caml_option.some(error._0);
                  return {
                          TAG: /* UpdateWithSideEffects */1,
                          _0: {
                            input: state.input,
                            fieldsStatuses: match$1.fieldsStatuses,
                            collectionsStatuses: match$1.collectionsStatuses,
                            formStatus: {
                              TAG: /* Submitting */0,
                              _0: tmp
                            },
                            submissionStatus: /* AttemptedToSubmit */1
                          },
                          _1: (function (param) {
                              var dispatch = param.dispatch;
                              return Curry._2(onSubmit, output, {
                                          notifyOnSuccess: (function (input) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmittedStatus */22,
                                                          _0: input
                                                        });
                                            }),
                                          notifyOnFailure: (function (error) {
                                              return Curry._1(dispatch, {
                                                          TAG: /* SetSubmissionFailedStatus */23,
                                                          _0: error
                                                        });
                                            }),
                                          reset: (function (param) {
                                              return Curry._1(dispatch, /* Reset */25);
                                            }),
                                          dismissSubmissionResult: (function (param) {
                                              return Curry._1(dispatch, /* DismissSubmissionResult */24);
                                            })
                                        });
                            })
                        };
                  break;
              case /* DismissSubmissionError */23 :
                  var match$2 = state.formStatus;
                  if (typeof match$2 === "number" || match$2.TAG !== /* SubmissionFailed */1) {
                    return /* NoUpdate */0;
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Editing */0,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* DismissSubmissionResult */24 :
                  var match$3 = state.formStatus;
                  if (typeof match$3 === "number") {
                    if (match$3 === /* Editing */0) {
                      return /* NoUpdate */0;
                    }
                    
                  } else if (match$3.TAG === /* Submitting */0) {
                    return /* NoUpdate */0;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: /* Editing */0,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Reset */25 :
                  return {
                          TAG: /* Update */0,
                          _0: initialState(initialInput)
                        };
              
            }
          } else {
            switch (action.TAG | 0) {
              case /* UpdateMaxDryRunDeltaField */0 :
                  var nextInput = Curry._1(action._0, state.input);
                  var nextFieldsStatuses = {
                    contents: state.fieldsStatuses
                  };
                  var result$22 = Formality.validateDependentFieldOnChange(nextInput, nextFieldsStatuses.contents.subType, validators_subType, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses.contents);
                          newrecord.subType = status;
                          return newrecord;
                        }));
                  if (result$22 !== undefined) {
                    nextFieldsStatuses.contents = result$22;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput, nextFieldsStatuses.contents.maxDryRunDelta, state.submissionStatus, validators_maxDryRunDelta, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses.contents);
                                    newrecord.maxDryRunDelta = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateMaxDryRunAutomaticField */1 :
                  var nextInput$1 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$1 = {
                    contents: state.fieldsStatuses
                  };
                  var result$23 = Formality.validateDependentFieldOnChange(nextInput$1, nextFieldsStatuses$1.contents.subType, validators_subType, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$1.contents);
                          newrecord.subType = status;
                          return newrecord;
                        }));
                  if (result$23 !== undefined) {
                    nextFieldsStatuses$1.contents = result$23;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$1,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$1, nextFieldsStatuses$1.contents.maxDryRunAutomatic, state.submissionStatus, validators_maxDryRunAutomatic, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$1.contents);
                                    newrecord.maxDryRunAutomatic = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateMaxDryRunManualField */2 :
                  var nextInput$2 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$2 = {
                    contents: state.fieldsStatuses
                  };
                  var result$24 = Formality.validateDependentFieldOnChange(nextInput$2, nextFieldsStatuses$2.contents.subType, validators_subType, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$2.contents);
                          newrecord.subType = status;
                          return newrecord;
                        }));
                  if (result$24 !== undefined) {
                    nextFieldsStatuses$2.contents = result$24;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$2,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$2, nextFieldsStatuses$2.contents.maxDryRunManual, state.submissionStatus, validators_maxDryRunManual, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$2.contents);
                                    newrecord.maxDryRunManual = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateDryRunDeltaField */3 :
                  var nextInput$3 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$3 = {
                    contents: state.fieldsStatuses
                  };
                  var result$25 = Formality.validateDependentFieldOnChange(nextInput$3, nextFieldsStatuses$3.contents.subType, validators_subType, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$3.contents);
                          newrecord.subType = status;
                          return newrecord;
                        }));
                  if (result$25 !== undefined) {
                    nextFieldsStatuses$3.contents = result$25;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$3,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$3, nextFieldsStatuses$3.contents.dryRunDelta, state.submissionStatus, validators_dryRunDelta, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$3.contents);
                                    newrecord.dryRunDelta = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateDryRunRatioField */4 :
                  var nextInput$4 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$4 = {
                    contents: state.fieldsStatuses
                  };
                  var result$26 = Formality.validateDependentFieldOnChange(nextInput$4, nextFieldsStatuses$4.contents.subType, validators_subType, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$4.contents);
                          newrecord.subType = status;
                          return newrecord;
                        }));
                  if (result$26 !== undefined) {
                    nextFieldsStatuses$4.contents = result$26;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$4,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$4, nextFieldsStatuses$4.contents.dryRunRatio, state.submissionStatus, validators_dryRunRatio, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$4.contents);
                                    newrecord.dryRunRatio = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateThresholdDistanceField */5 :
                  var nextInput$5 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$5 = {
                    contents: state.fieldsStatuses
                  };
                  var result$27 = Formality.validateDependentFieldOnChange(nextInput$5, nextFieldsStatuses$5.contents.subType, validators_subType, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$5.contents);
                          newrecord.subType = status;
                          return newrecord;
                        }));
                  if (result$27 !== undefined) {
                    nextFieldsStatuses$5.contents = result$27;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$5,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$5, nextFieldsStatuses$5.contents.thresholdDistance, state.submissionStatus, validators_thresholdDistance, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$5.contents);
                                    newrecord.thresholdDistance = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateAllocationRadiusDeltaField */6 :
                  var nextInput$6 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$6 = {
                    contents: state.fieldsStatuses
                  };
                  var result$28 = Formality.validateDependentFieldOnChange(nextInput$6, nextFieldsStatuses$6.contents.subType, validators_subType, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$6.contents);
                          newrecord.subType = status;
                          return newrecord;
                        }));
                  if (result$28 !== undefined) {
                    nextFieldsStatuses$6.contents = result$28;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$6,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$6, nextFieldsStatuses$6.contents.allocationRadiusDelta, state.submissionStatus, validators_allocationRadiusDelta, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$6.contents);
                                    newrecord.allocationRadiusDelta = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateAllocationRadiusAutomaticField */7 :
                  var nextInput$7 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$7 = {
                    contents: state.fieldsStatuses
                  };
                  var result$29 = Formality.validateDependentFieldOnChange(nextInput$7, nextFieldsStatuses$7.contents.subType, validators_subType, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$7.contents);
                          newrecord.subType = status;
                          return newrecord;
                        }));
                  if (result$29 !== undefined) {
                    nextFieldsStatuses$7.contents = result$29;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$7,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$7, nextFieldsStatuses$7.contents.allocationRadiusAutomatic, state.submissionStatus, validators_allocationRadiusAutomatic, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$7.contents);
                                    newrecord.allocationRadiusAutomatic = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateAllocationRadiusManualField */8 :
                  var nextInput$8 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$8 = {
                    contents: state.fieldsStatuses
                  };
                  var result$30 = Formality.validateDependentFieldOnChange(nextInput$8, nextFieldsStatuses$8.contents.subType, validators_subType, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$8.contents);
                          newrecord.subType = status;
                          return newrecord;
                        }));
                  if (result$30 !== undefined) {
                    nextFieldsStatuses$8.contents = result$30;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$8,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$8, nextFieldsStatuses$8.contents.allocationRadiusManual, state.submissionStatus, validators_allocationRadiusManual, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$8.contents);
                                    newrecord.allocationRadiusManual = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateDisplayFiltersField */9 :
                  var nextInput$9 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$9,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$9.displayFilters, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                                    newrecord.displayFilters = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateSubTypeField */10 :
                  var nextInput$10 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$9 = {
                    contents: state.fieldsStatuses
                  };
                  var result$31 = Formality.validateDependentFieldOnChange(nextInput$10, nextFieldsStatuses$9.contents.allocationRadiusManual, validators_allocationRadiusManual, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$9.contents);
                          newrecord.allocationRadiusManual = status;
                          return newrecord;
                        }));
                  if (result$31 !== undefined) {
                    nextFieldsStatuses$9.contents = result$31;
                  }
                  var result$32 = Formality.validateDependentFieldOnChange(nextInput$10, nextFieldsStatuses$9.contents.allocationRadiusAutomatic, validators_allocationRadiusAutomatic, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$9.contents);
                          newrecord.allocationRadiusAutomatic = status;
                          return newrecord;
                        }));
                  if (result$32 !== undefined) {
                    nextFieldsStatuses$9.contents = result$32;
                  }
                  var result$33 = Formality.validateDependentFieldOnChange(nextInput$10, nextFieldsStatuses$9.contents.thresholdDistance, validators_thresholdDistance, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$9.contents);
                          newrecord.thresholdDistance = status;
                          return newrecord;
                        }));
                  if (result$33 !== undefined) {
                    nextFieldsStatuses$9.contents = result$33;
                  }
                  var result$34 = Formality.validateDependentFieldOnChange(nextInput$10, nextFieldsStatuses$9.contents.dryRunRatio, validators_dryRunRatio, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$9.contents);
                          newrecord.dryRunRatio = status;
                          return newrecord;
                        }));
                  if (result$34 !== undefined) {
                    nextFieldsStatuses$9.contents = result$34;
                  }
                  var result$35 = Formality.validateDependentFieldOnChange(nextInput$10, nextFieldsStatuses$9.contents.maxDryRunManual, validators_maxDryRunManual, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$9.contents);
                          newrecord.maxDryRunManual = status;
                          return newrecord;
                        }));
                  if (result$35 !== undefined) {
                    nextFieldsStatuses$9.contents = result$35;
                  }
                  var result$36 = Formality.validateDependentFieldOnChange(nextInput$10, nextFieldsStatuses$9.contents.maxDryRunAutomatic, validators_maxDryRunAutomatic, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$9.contents);
                          newrecord.maxDryRunAutomatic = status;
                          return newrecord;
                        }));
                  if (result$36 !== undefined) {
                    nextFieldsStatuses$9.contents = result$36;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$10,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$10, nextFieldsStatuses$9.contents.subType, state.submissionStatus, validators_subType, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$9.contents);
                                    newrecord.subType = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* Update_typeField */11 :
                  var nextInput$11 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$11,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$11._type, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                                    newrecord._type = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateValidationsField */12 :
                  var nextInput$12 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$12,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$12.validations, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                                    newrecord.validations = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateDaysField */13 :
                  var nextInput$13 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$13,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$13, state.fieldsStatuses.days, state.submissionStatus, validators_days, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                                    newrecord.days = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateEndTimeField */14 :
                  var nextInput$14 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$10 = {
                    contents: state.fieldsStatuses
                  };
                  var result$37 = Formality.validateDependentFieldOnChange(nextInput$14, nextFieldsStatuses$10.contents.endDate, validators_endDate, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$10.contents);
                          newrecord.endDate = status;
                          return newrecord;
                        }));
                  if (result$37 !== undefined) {
                    nextFieldsStatuses$10.contents = result$37;
                  }
                  var result$38 = Formality.validateDependentFieldOnChange(nextInput$14, nextFieldsStatuses$10.contents.startTime, validators_startTime, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$10.contents);
                          newrecord.startTime = status;
                          return newrecord;
                        }));
                  if (result$38 !== undefined) {
                    nextFieldsStatuses$10.contents = result$38;
                  }
                  var result$39 = Formality.validateDependentFieldOnChange(nextInput$14, nextFieldsStatuses$10.contents.startDate, validators_startDate, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$10.contents);
                          newrecord.startDate = status;
                          return newrecord;
                        }));
                  if (result$39 !== undefined) {
                    nextFieldsStatuses$10.contents = result$39;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$14,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$14, nextFieldsStatuses$10.contents.endTime, state.submissionStatus, validators_endTime, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$10.contents);
                                    newrecord.endTime = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateEndDateField */15 :
                  var nextInput$15 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$11 = {
                    contents: state.fieldsStatuses
                  };
                  var result$40 = Formality.validateDependentFieldOnChange(nextInput$15, nextFieldsStatuses$11.contents.startDate, validators_startDate, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$11.contents);
                          newrecord.startDate = status;
                          return newrecord;
                        }));
                  if (result$40 !== undefined) {
                    nextFieldsStatuses$11.contents = result$40;
                  }
                  var result$41 = Formality.validateDependentFieldOnChange(nextInput$15, nextFieldsStatuses$11.contents.startTime, validators_startTime, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$11.contents);
                          newrecord.startTime = status;
                          return newrecord;
                        }));
                  if (result$41 !== undefined) {
                    nextFieldsStatuses$11.contents = result$41;
                  }
                  var result$42 = Formality.validateDependentFieldOnChange(nextInput$15, nextFieldsStatuses$11.contents.endTime, validators_endTime, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$11.contents);
                          newrecord.endTime = status;
                          return newrecord;
                        }));
                  if (result$42 !== undefined) {
                    nextFieldsStatuses$11.contents = result$42;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$15,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$15, nextFieldsStatuses$11.contents.endDate, state.submissionStatus, validators_endDate, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$11.contents);
                                    newrecord.endDate = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateStartTimeField */16 :
                  var nextInput$16 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$12 = {
                    contents: state.fieldsStatuses
                  };
                  var result$43 = Formality.validateDependentFieldOnChange(nextInput$16, nextFieldsStatuses$12.contents.endDate, validators_endDate, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$12.contents);
                          newrecord.endDate = status;
                          return newrecord;
                        }));
                  if (result$43 !== undefined) {
                    nextFieldsStatuses$12.contents = result$43;
                  }
                  var result$44 = Formality.validateDependentFieldOnChange(nextInput$16, nextFieldsStatuses$12.contents.startDate, validators_startDate, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$12.contents);
                          newrecord.startDate = status;
                          return newrecord;
                        }));
                  if (result$44 !== undefined) {
                    nextFieldsStatuses$12.contents = result$44;
                  }
                  var result$45 = Formality.validateDependentFieldOnChange(nextInput$16, nextFieldsStatuses$12.contents.endTime, validators_endTime, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$12.contents);
                          newrecord.endTime = status;
                          return newrecord;
                        }));
                  if (result$45 !== undefined) {
                    nextFieldsStatuses$12.contents = result$45;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$16,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$16, nextFieldsStatuses$12.contents.startTime, state.submissionStatus, validators_startTime, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$12.contents);
                                    newrecord.startTime = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateStartDateField */17 :
                  var nextInput$17 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$13 = {
                    contents: state.fieldsStatuses
                  };
                  var result$46 = Formality.validateDependentFieldOnChange(nextInput$17, nextFieldsStatuses$13.contents.endDate, validators_endDate, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$13.contents);
                          newrecord.endDate = status;
                          return newrecord;
                        }));
                  if (result$46 !== undefined) {
                    nextFieldsStatuses$13.contents = result$46;
                  }
                  var result$47 = Formality.validateDependentFieldOnChange(nextInput$17, nextFieldsStatuses$13.contents.startTime, validators_startTime, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$13.contents);
                          newrecord.startTime = status;
                          return newrecord;
                        }));
                  if (result$47 !== undefined) {
                    nextFieldsStatuses$13.contents = result$47;
                  }
                  var result$48 = Formality.validateDependentFieldOnChange(nextInput$17, nextFieldsStatuses$13.contents.endTime, validators_endTime, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$13.contents);
                          newrecord.endTime = status;
                          return newrecord;
                        }));
                  if (result$48 !== undefined) {
                    nextFieldsStatuses$13.contents = result$48;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$17,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$17, nextFieldsStatuses$13.contents.startDate, state.submissionStatus, validators_startDate, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$13.contents);
                                    newrecord.startDate = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateCampaignNameField */18 :
                  var nextInput$18 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$18,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$18, state.fieldsStatuses.campaignName, state.submissionStatus, validators_campaignName, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                                    newrecord.campaignName = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateClustersField */19 :
                  var nextInput$19 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$19,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$19, state.fieldsStatuses.clusters, state.submissionStatus, validators_clusters, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                                    newrecord.clusters = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateHasClusterField */20 :
                  var nextInput$20 = Curry._1(action._0, state.input);
                  var nextFieldsStatuses$14 = {
                    contents: state.fieldsStatuses
                  };
                  var result$49 = Formality.validateDependentFieldOnChange(nextInput$20, nextFieldsStatuses$14.contents.clusters, validators_clusters, (function (status) {
                          var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$14.contents);
                          newrecord.clusters = status;
                          return newrecord;
                        }));
                  if (result$49 !== undefined) {
                    nextFieldsStatuses$14.contents = result$49;
                  }
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$20,
                            fieldsStatuses: Formality.validateFieldOnChangeWithoutValidator(nextInput$20.hasCluster, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(nextFieldsStatuses$14.contents);
                                    newrecord.hasCluster = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* UpdateZonesField */21 :
                  var nextInput$21 = Curry._1(action._0, state.input);
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: nextInput$21,
                            fieldsStatuses: Formality.validateFieldOnChangeWithValidator(nextInput$21, state.fieldsStatuses.zones, state.submissionStatus, validators_zones, (function (status) {
                                    var newrecord = Caml_obj.caml_obj_dup(state.fieldsStatuses);
                                    newrecord.zones = status;
                                    return newrecord;
                                  })),
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: state.formStatus,
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* SetSubmittedStatus */22 :
                  var input = action._0;
                  if (input !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: input,
                              fieldsStatuses: initialFieldsStatuses(input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: initialFieldsStatuses(state.input),
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: /* Submitted */1,
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
              case /* SetSubmissionFailedStatus */23 :
                  return {
                          TAG: /* Update */0,
                          _0: {
                            input: state.input,
                            fieldsStatuses: state.fieldsStatuses,
                            collectionsStatuses: state.collectionsStatuses,
                            formStatus: {
                              TAG: /* SubmissionFailed */1,
                              _0: action._0
                            },
                            submissionStatus: state.submissionStatus
                          }
                        };
              case /* MapSubmissionError */24 :
                  var map = action._0;
                  var error$1 = state.formStatus;
                  if (typeof error$1 === "number") {
                    return /* NoUpdate */0;
                  }
                  if (error$1.TAG !== /* Submitting */0) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* SubmissionFailed */1,
                                _0: Curry._1(map, error$1._0)
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  }
                  var error$2 = error$1._0;
                  if (error$2 !== undefined) {
                    return {
                            TAG: /* Update */0,
                            _0: {
                              input: state.input,
                              fieldsStatuses: state.fieldsStatuses,
                              collectionsStatuses: state.collectionsStatuses,
                              formStatus: {
                                TAG: /* Submitting */0,
                                _0: Caml_option.some(Curry._1(map, Caml_option.valFromOption(error$2)))
                              },
                              submissionStatus: state.submissionStatus
                            }
                          };
                  } else {
                    return /* NoUpdate */0;
                  }
              
            }
          }
        }));
  var dispatch = match[1];
  var state = match[0];
  var match$1 = state.formStatus;
  var tmp;
  tmp = typeof match$1 === "number" || match$1.TAG !== /* Submitting */0 ? false : true;
  return {
          updateMaxDryRunDelta: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateMaxDryRunDeltaField */0,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateMaxDryRunAutomatic: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateMaxDryRunAutomaticField */1,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateMaxDryRunManual: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateMaxDryRunManualField */2,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateDryRunDelta: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateDryRunDeltaField */3,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateDryRunRatio: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateDryRunRatioField */4,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateThresholdDistance: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateThresholdDistanceField */5,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateAllocationRadiusDelta: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateAllocationRadiusDeltaField */6,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateAllocationRadiusAutomatic: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateAllocationRadiusAutomaticField */7,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateAllocationRadiusManual: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateAllocationRadiusManualField */8,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateDisplayFilters: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateDisplayFiltersField */9,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateSubType: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateSubTypeField */10,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          update_type: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* Update_typeField */11,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateValidations: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateValidationsField */12,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateDays: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateDaysField */13,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateEndTime: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateEndTimeField */14,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateEndDate: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateEndDateField */15,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateStartTime: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateStartTimeField */16,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateStartDate: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateStartDateField */17,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateCampaignName: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateCampaignNameField */18,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateClusters: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateClustersField */19,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateHasCluster: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateHasClusterField */20,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          updateZones: (function (nextInputFn, nextValue) {
              return Curry._1(dispatch, {
                          TAG: /* UpdateZonesField */21,
                          _0: (function (__x) {
                              return Curry._2(nextInputFn, __x, nextValue);
                            })
                        });
            }),
          blurMaxDryRunDelta: (function (param) {
              return Curry._1(dispatch, /* BlurMaxDryRunDeltaField */0);
            }),
          blurMaxDryRunAutomatic: (function (param) {
              return Curry._1(dispatch, /* BlurMaxDryRunAutomaticField */1);
            }),
          blurMaxDryRunManual: (function (param) {
              return Curry._1(dispatch, /* BlurMaxDryRunManualField */2);
            }),
          blurDryRunDelta: (function (param) {
              return Curry._1(dispatch, /* BlurDryRunDeltaField */3);
            }),
          blurDryRunRatio: (function (param) {
              return Curry._1(dispatch, /* BlurDryRunRatioField */4);
            }),
          blurThresholdDistance: (function (param) {
              return Curry._1(dispatch, /* BlurThresholdDistanceField */5);
            }),
          blurAllocationRadiusDelta: (function (param) {
              return Curry._1(dispatch, /* BlurAllocationRadiusDeltaField */6);
            }),
          blurAllocationRadiusAutomatic: (function (param) {
              return Curry._1(dispatch, /* BlurAllocationRadiusAutomaticField */7);
            }),
          blurAllocationRadiusManual: (function (param) {
              return Curry._1(dispatch, /* BlurAllocationRadiusManualField */8);
            }),
          blurDisplayFilters: (function (param) {
              return Curry._1(dispatch, /* BlurDisplayFiltersField */9);
            }),
          blurSubType: (function (param) {
              return Curry._1(dispatch, /* BlurSubTypeField */10);
            }),
          blur_type: (function (param) {
              return Curry._1(dispatch, /* Blur_typeField */11);
            }),
          blurValidations: (function (param) {
              return Curry._1(dispatch, /* BlurValidationsField */12);
            }),
          blurDays: (function (param) {
              return Curry._1(dispatch, /* BlurDaysField */13);
            }),
          blurEndTime: (function (param) {
              return Curry._1(dispatch, /* BlurEndTimeField */14);
            }),
          blurEndDate: (function (param) {
              return Curry._1(dispatch, /* BlurEndDateField */15);
            }),
          blurStartTime: (function (param) {
              return Curry._1(dispatch, /* BlurStartTimeField */16);
            }),
          blurStartDate: (function (param) {
              return Curry._1(dispatch, /* BlurStartDateField */17);
            }),
          blurCampaignName: (function (param) {
              return Curry._1(dispatch, /* BlurCampaignNameField */18);
            }),
          blurClusters: (function (param) {
              return Curry._1(dispatch, /* BlurClustersField */19);
            }),
          blurHasCluster: (function (param) {
              return Curry._1(dispatch, /* BlurHasClusterField */20);
            }),
          blurZones: (function (param) {
              return Curry._1(dispatch, /* BlurZonesField */21);
            }),
          maxDryRunDeltaResult: Formality.exposeFieldResult(state.fieldsStatuses.maxDryRunDelta),
          maxDryRunAutomaticResult: Formality.exposeFieldResult(state.fieldsStatuses.maxDryRunAutomatic),
          maxDryRunManualResult: Formality.exposeFieldResult(state.fieldsStatuses.maxDryRunManual),
          dryRunDeltaResult: Formality.exposeFieldResult(state.fieldsStatuses.dryRunDelta),
          dryRunRatioResult: Formality.exposeFieldResult(state.fieldsStatuses.dryRunRatio),
          thresholdDistanceResult: Formality.exposeFieldResult(state.fieldsStatuses.thresholdDistance),
          allocationRadiusDeltaResult: Formality.exposeFieldResult(state.fieldsStatuses.allocationRadiusDelta),
          allocationRadiusAutomaticResult: Formality.exposeFieldResult(state.fieldsStatuses.allocationRadiusAutomatic),
          allocationRadiusManualResult: Formality.exposeFieldResult(state.fieldsStatuses.allocationRadiusManual),
          displayFiltersResult: Formality.exposeFieldResult(state.fieldsStatuses.displayFilters),
          subTypeResult: Formality.exposeFieldResult(state.fieldsStatuses.subType),
          _typeResult: Formality.exposeFieldResult(state.fieldsStatuses._type),
          validationsResult: Formality.exposeFieldResult(state.fieldsStatuses.validations),
          daysResult: Formality.exposeFieldResult(state.fieldsStatuses.days),
          endTimeResult: Formality.exposeFieldResult(state.fieldsStatuses.endTime),
          endDateResult: Formality.exposeFieldResult(state.fieldsStatuses.endDate),
          startTimeResult: Formality.exposeFieldResult(state.fieldsStatuses.startTime),
          startDateResult: Formality.exposeFieldResult(state.fieldsStatuses.startDate),
          campaignNameResult: Formality.exposeFieldResult(state.fieldsStatuses.campaignName),
          clustersResult: Formality.exposeFieldResult(state.fieldsStatuses.clusters),
          hasClusterResult: Formality.exposeFieldResult(state.fieldsStatuses.hasCluster),
          zonesResult: Formality.exposeFieldResult(state.fieldsStatuses.zones),
          input: state.input,
          status: state.formStatus,
          dirty: (function (param) {
              var match = state.fieldsStatuses;
              var exit = 0;
              if (match.maxDryRunDelta || match.maxDryRunAutomatic || match.maxDryRunManual || match.dryRunDelta || match.dryRunRatio || match.thresholdDistance || match.allocationRadiusDelta || match.allocationRadiusAutomatic || match.allocationRadiusManual || match.displayFilters || match.subType || match._type || match.validations || match.days || match.endTime || match.endDate || match.startTime || match.startDate || match.campaignName || match.clusters || match.hasCluster) {
                exit = 1;
              } else {
                if (!match.zones) {
                  return false;
                }
                exit = 1;
              }
              if (exit === 1) {
                var exit$1 = 0;
                exit$1 = 2;
                if (exit$1 === 2) {
                  var exit$2 = 0;
                  exit$2 = 3;
                  if (exit$2 === 3) {
                    var exit$3 = 0;
                    exit$3 = 4;
                    if (exit$3 === 4) {
                      var exit$4 = 0;
                      exit$4 = 5;
                      if (exit$4 === 5) {
                        var exit$5 = 0;
                        exit$5 = 6;
                        if (exit$5 === 6) {
                          var exit$6 = 0;
                          exit$6 = 7;
                          if (exit$6 === 7) {
                            var exit$7 = 0;
                            exit$7 = 8;
                            if (exit$7 === 8) {
                              var exit$8 = 0;
                              exit$8 = 9;
                              if (exit$8 === 9) {
                                var exit$9 = 0;
                                exit$9 = 10;
                                if (exit$9 === 10) {
                                  var exit$10 = 0;
                                  exit$10 = 11;
                                  if (exit$10 === 11) {
                                    return true;
                                  }
                                  
                                }
                                
                              }
                              
                            }
                            
                          }
                          
                        }
                        
                      }
                      
                    }
                    
                  }
                  
                }
                
              }
              
            }),
          valid: (function (param) {
              var match = validateForm(state.input, validators, state.fieldsStatuses);
              if (match.TAG === /* Valid */0) {
                return true;
              } else {
                return false;
              }
            }),
          submitting: tmp,
          submit: (function (param) {
              return Curry._1(dispatch, /* Submit */22);
            }),
          dismissSubmissionError: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionError */23);
            }),
          dismissSubmissionResult: (function (param) {
              return Curry._1(dispatch, /* DismissSubmissionResult */24);
            }),
          mapSubmissionError: (function (map) {
              return Curry._1(dispatch, {
                          TAG: /* MapSubmissionError */24,
                          _0: map
                        });
            }),
          reset: (function (param) {
              return Curry._1(dispatch, /* Reset */25);
            })
        };
}

var Form = {
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

export {
  validateFilterTypes ,
  Form ,
  
}
/* react Not a pure module */
